import { useContext } from 'react'
import { AppLayoutContext } from '@/context/AppLayoutContext'

export const useAppLayoutContext = () => {
  const context = useContext(AppLayoutContext)

  if (!context) {
    throw new Error(
      'Component must be used within an AppLayoutContext.Provider',
    )
  }

  return context
}
